import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Spinner } from "react-bootstrap";
import AddTraderDetails from "./AddTraderDetails";
import AddTraderConfirmation from "./AddTraderConfirmation";
import { Trader } from "./trader";
import ValidationError from "common/validationError";
import { useEffect } from "react";
import AsyncButton from "common/ui/AsyncButton";

export type AddTraderProps = {
  trader: any;
  showModal: boolean;
  showEditMode: boolean;
  handleCancel: () => void;
  handleSubmit: (trader: Trader) => Promise<any>;
  showDeleteModal: () => void;
};

const AddTraderModal: React.FC<AddTraderProps> = (props) => {

  const [trader, setTrader] = useState<Trader>(props.trader);
  const [showConfirmation, setShowConfirmation]= useState(false);
  const [isSubmitting, setIsSubmitting]= useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [validated, setValidated] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>(null);

  useEffect(() => {
    if (!showConfirmation) {
      setModalTitle(props.showEditMode ? "Edit Trader" : "Add Trader");
    } else {
      setModalTitle(props.showEditMode
        ? "Review and Confirm Edit Trader"
        : "Review and Confirm New Trader");
    }
  }, [showConfirmation, props.showEditMode]);

  useEffect(() => setTrader(props.trader), [props.trader]);
  
  function goBack() {
    setShowConfirmation(false);
    setIsSubmitting(false);
  }

  function goNext(event:any) {
    const traderForm = event.currentTarget;  
    if (traderForm.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
    else {
      setShowConfirmation(true);
      setErrors([]);
    }
    setValidated(true);
  }

  async function handleSubmit() {

    setIsSubmitting(true);
    try {
      await props.handleSubmit(trader);
      setShowConfirmation(false);
    }
    catch (err) {
      setErrors((err as ValidationError).errors);
    }
    finally {
      setIsSubmitting(false);
    }
  }

  function handleAbort() {
    setShowConfirmation(false);
    setIsSubmitting(false);
    props.handleCancel();
  }

  

  return (
    <Modal show={props.showModal} onHide={handleAbort} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>

      {!showConfirmation && (
        <>
          <Modal.Body>
            <AddTraderDetails
              trader={trader}
              onTraderUpdated={m => setTrader(m)}
              showEditMode = {props.showEditMode}
              handleNext = {goNext}
              validated = {validated}
              handleCancel = {handleAbort}
              showDeleteModal={props.showDeleteModal}
            />
          </Modal.Body>
        </>
      )}
      {showConfirmation && (
        <>
          <Modal.Body className="add-offer-modal">
            {!isSubmitting && (
              <AddTraderConfirmation
                trader={trader}
                errors={errors}
              />
            )}
            {isSubmitting && <Spinner animation="border" />}
          </Modal.Body>
          <Modal.Footer className="align center">
            <Button
              variant="secondary"
              className="float-left"
              onClick={goBack}
            >
              Go Back
            </Button>
            <Button variant="secondary" onClick={handleAbort}>
              Cancel
            </Button>
            <AsyncButton variant="primary" onClickAsync={handleSubmit}>
              {props.showEditMode ? "Update" : "Create"}
            </AsyncButton>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default AddTraderModal